const { isEmojiCharacter } = require('@util')

export const validatorCoverPath = (rule, value, callback) => {
  callback()
}

export const checkEmoji = (rule, value, callback) => {
  if (isEmojiCharacter(value)) {
    callback('禁止输入表情符号')
  }
  callback()
}
